import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/auth.context';
import { Form, InputGroup, Button } from 'react-bootstrap';
import i18n from '../../i18n';
import { updateEmail, updateSettings } from '../../actions/auth.action'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/pro-light-svg-icons";
import { faSpinner } from '@fortawesome/pro-duotone-svg-icons';
import { getUrlEmail } from '../../services/utils';

const EmailStepComponent: React.FC = () => {

  const { t } = i18n
  const { email, settings, loading, dispatch } = useAuth();
  const [formValidated, setFormValidated] = useState(false);

  useEffect(() => {
    const decodedEmail = getUrlEmail();
    if (decodedEmail) {
      dispatch(updateEmail(decodedEmail));
    }
  }, [dispatch]);

  const handleSubmit: React.FormEventHandler<HTMLFormElement> = async (event) => {
    setFormValidated(false);
    const form = event.currentTarget;
    event.preventDefault();

    if (form.checkValidity()) {
      dispatch(updateSettings({ ...settings, error: '', emailConfirmed: true}))
    } else {
      event.stopPropagation();
    }

    setFormValidated(true);
  }

  return (
    <>
      {!settings.emailConfirmed &&
        <Form noValidate validated={formValidated} onSubmit={handleSubmit}>
          <InputGroup className="mb-2">
            <InputGroup.Text><FontAwesomeIcon icon={faUser} /></InputGroup.Text>
            <Form.Control
              placeholder={t('email')}
              aria-label="Email"
              required
              type="email"
              onChange={(e) => dispatch(updateEmail(e.target.value))}
              id={'username'}
              autoComplete={'username'}
              defaultValue={email}
              disabled={loading}
              readOnly={loading}
              autoFocus
            />
            <Form.Control.Feedback type="invalid">
              {email ? `${t('invalid_field', { field: t('email') })}` : t('field_cannot_be_blank', { field: t('email') })}
            </Form.Control.Feedback>

          </InputGroup>

          <Button variant="primary" type="submit" disabled={loading} className="mt-3 fixed-width-submit-button">
            <div className="notranslate d-flex align-items-center justify-content-center" translate="no">
              {loading && <FontAwesomeIcon icon={faSpinner} className="fa-spin me-2" />}
              {t('continue')}
            </div>
          </Button>
        </Form>
      }
    </>
  );
};

export default EmailStepComponent;
